import { I18n } from '@calendly/i18n';
import { Segment } from '@calendly/segment';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CheckCircleIcon, ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { primaryColorL2 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserQuery } from 'common';
import { useBillingPath } from 'features/billing';
import UpgradeToEnterprise from 'images/icons/upgrade-to-enterprise.svg';
import { currentOrganizationSelector } from 'selectors/current_organization';
const paywallBoundingBoxIsPhoneCss = "p1czh4ys";
const paywallBoundingBoxCss = "p842fj7";
const PaywallBoundingBox = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(paywallBoundingBoxCss, {
    [paywallBoundingBoxIsPhoneCss]: isPhone
  }, props.className)} />;
});
const contentContainerIsPhoneCss = "c1o3qk0u";
const contentContainerCss = "c18go984";
const ContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(contentContainerCss, {
    [contentContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const listContentContainerCss = "lfh1k49";
const ListContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listContentContainerCss, props.className)} />;
});
const iconContainerIsPhoneCss = "itl7tio";
const iconContainerCss = "i1kcgap0";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, {
    [iconContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const enterpriseIconIsPhoneCss = "e14pk3a2";
const enterpriseIconCss = "e3y3lfm";
const EnterpriseIcon = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <UpgradeToEnterprise ref={ref} {...props} className={classNames(enterpriseIconCss, {
    [enterpriseIconIsPhoneCss]: isPhone
  }, props.className)} />;
});
const domainOptionsListCss = "dui5nuh";
const DomainOptionsList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(domainOptionsListCss, props.className)} />;
});
const styledOptionSpanCss = "s1p67dfa";
const StyledOptionSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledOptionSpanCss, props.className)} />;
});
const optionListItemCss = "o1awzrra";
const OptionListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(optionListItemCss, props.className)} />;
});
const contactButtonIsPhoneCss = "codi8xm";
const contactButtonCss = "c18r55ko";
const ContactButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(contactButtonCss, {
    [contactButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const Paywall = () => {
  const {
    id: organizationId
  } = useSelector(currentOrganizationSelector);
  const {
    data: {
      id: userId
    }
  } = useGetUserQuery();
  const contactSalesPath = useBillingPath('/contact_sales');
  const optionItems = () => [I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.multiple_domains_check'), I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.prevent_new_account_creation_check'), I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.request_access_check'), I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.automated_process_check')].map(translationString => <OptionListItem key={translationString}>
      <CheckCircleIcon color={primaryColorL2} />
      <StyledOptionSpan>{translationString}</StyledOptionSpan>
    </OptionListItem>);
  const onContactButtonClick = () => {
    Segment.track('domain_control.contact_us_clicked', {
      organization_id: organizationId,
      user_id: userId
    });
  };
  return <PaywallBoundingBox>
      <ContentContainer>
        <IconContainer>
          <EnterpriseIcon />
        </IconContainer>
        <ListContentContainer>
          <TitleText level={2} size="medium">
            {I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.title')}
          </TitleText>
          <DomainOptionsList>
            {optionItems()}
          </DomainOptionsList>
          <ContactButton decoration="secondary-outline" as="a" href={contactSalesPath} rel="noopener" target="_blank" onClick={onContactButtonClick}>
            {I18n.t('publisher.admin.login.page.user_access.form_options.domain_control.paywall.button_label')}
            <ArrowExpandIcon />
          </ContactButton>
        </ListContentContainer>
      </ContentContainer>
    </PaywallBoundingBox>;
};

require("./paywall.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./paywall.js");